import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { TaskNanoID, TaskUUID } from '../../../tasksTypes';
import {
  FETCH_TASK_RESULT_DOWNLOAD_URLS_QUERY,
  FetchTaskResultDownloadUrlsQueryResponse
} from '../../../queries/fetchTaskResultDownloadUrls.query';

import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';
import { useTask } from '../../../hooks/useTask';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

import { TaskCache } from '../../../TaskCache';

interface DownloadTaskResultsSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  taskUuid: TaskUUID | TaskNanoID;
  togglePreventModalClose?: () => void;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadTaskResultsSeparatelyButton({
  className,
  dataGa,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  taskUuid,
  togglePreventModalClose,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadTaskResultsSeparatelyButtonProps & GADataType) {
  const { taskLoading, refetchTask, taskError } =
    useTask<FetchTaskResultDownloadUrlsQueryResponse>({
      cacheKey: TaskCache.resultDownloadUrls(taskUuid),
      options: {
        enabled: false,
        enabledPlaceholder: false
      },
      query: FETCH_TASK_RESULT_DOWNLOAD_URLS_QUERY,
      uuid: taskUuid
    });

  useShowToastOnErrorChange({ error: taskError });

  return (
    <DownloadUrlsModalButton<'task'>
      className={className}
      dataGa={dataGa}
      disabled={taskLoading}
      downloadUrlsScope="resultDownloadUrls"
      i18nText={i18nText}
      i18nTextClassName={i18nTextClassName}
      icon={icon || IconsEnum.DOWNLOAD_OUTLINE}
      iconClassName={iconClassName || 'h-6 w-6'}
      refetchItemDownloadUrls={refetchTask}
      scope="task"
      togglePreventModalClose={togglePreventModalClose}
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadTaskResultsSeparatelyButton;
